// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Sl-z","innerTile":"Tl-z","heading":"Ul-z","instaTileBtn":"Vl-z","disabled":"Wl-z","instaTileElement":"Xl-z","instagramPic":"Yl-z"};